<template>
  <md-card>
    <md-card-content>
      <md-table
          :value="queriedData"
          :md-sort.sync="currentSort"
          :md-sort-order.sync="currentSortOrder"
          :md-sort-fn="customSort"
          class="paginated-table table-striped table-hover"
      >
        <md-table-toolbar>
          <md-field>
            <label for="pages">Per page</label>
            <md-select v-model="pagination.perPage" name="pages">
              <md-option
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
              >
                {{ item }}
              </md-option>
            </md-select>
          </md-field>

          <md-field>
            <md-input
                type="search"
                class="mb-3"
                clearable
                style="width: 200px"
                placeholder="Search records"
                v-model="searchQuery"
            >
            </md-input>
          </md-field>
        </md-table-toolbar>

        <md-table-empty-state
            :md-label="`No ${listType} found`"
            :md-description="`No ${listType} found for this '${searchQuery}' query.
                        Try a different search term or attach new ${listType}.`">
          <md-button class="md-primary md-raised"
                     @click="$emit('addNewItem')">
            Attach {{ listType }}
          </md-button>
        </md-table-empty-state>

        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell
              v-for="(column,indexC) in tableColumns"
              :md-label="formatColumnName(column)"
              :md-sort-by="column"
              :key="indexC">
                       <span v-if="column === statusColumn" class="badge"
                             :class="'badge-'+getStatusBadgeClass(item[column])">
                        {{ item[column] || 'Unknown' }}
                      </span>
            <span v-else>{{ getNestedProperty(item, column) }}</span>
          </md-table-cell>
          <md-table-cell md-label="Actions">
            <md-button
                class="md-just-icon md-info md-simple"
                @click.native="handleViewItem(item)">
              <md-icon>dvr</md-icon>
            </md-button>
            <md-button
                class="md-just-icon md-warning md-simple"
                @click.native="handleEdit(item)">
              <md-icon>no_backpack</md-icon>
            </md-button>
            <md-button
                v-if="showEndButton"
                class="md-just-icon md-warning md-simple"
                title="End"
                @click="handleEnd(item)">
              <md-icon>stop_circle</md-icon>
            </md-button>
            <md-button
                v-if="showRemoveButton && can('delete-labourer-activity-workplace')"
                title="Remove Permanent"
                class="md-just-icon md-danger md-simple"
                @click="handleRemove(item)">
              <md-icon>cancel</md-icon>
            </md-button>
            <md-button
                v-else
                class="md-just-icon md-danger md-simple"
                title="Delete"
                @click="handleDelete(item)">
              <md-icon>delete</md-icon>
            </md-button>


          </md-table-cell>
        </md-table-row>
      </md-table>
    </md-card-content>
    <md-card-actions md-alignment="space-between">
      <div class="">
        <p class="card-category">
          Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
        </p>
      </div>
      <pagination
          class="pagination-no-border pagination-success"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
      >
      </pagination>
    </md-card-actions>
  </md-card>
</template>

<script>
import { Pagination } from '@/components';
import Swal from 'sweetalert2';
import Fuse from 'fuse.js';
import DateFormatMixin from '@/mixins/date-format-mixin';

export default {
    name: 'GeneralTable',
    components: { Pagination },
    mixins: [DateFormatMixin],
    props: {
        tableData: {
            type: Array
        },
        tableColumns: {
            type: Array,
            default: () => {
                return [];
            }
        },
        model: {
            type: Object,
            default: () => {
            }
        },
        type: {
            type: String,
            default: 'Model'
        },
        listType: {
            type: String,
            default: 'Model'
        },
        statusColumn: {
            type: String,
            default: 'status',
        },
        statusClassMap: {
            type: Object,
            default: () => ({}),
        },
      showRemoveButton: {
        type: Boolean,
        default: false
      },
      showEndButton: {
        type: Boolean,
        default: false
      }
    },
    data () {
        return {
            currentSort: 'name',
            currentSortOrder: 'asc',
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0
            },
            footerTable: ['Name', 'Email'],
            searchQuery: '',
            search: null,
            propsToSearch: ['name', 'email'],
            searchedData: [],
            searched: [],
            fuseSearch: null
        };
    },
    created () {
        this.searched = this.tableData;
    },
    methods: {
        customSort (value) {
            return value.sort((a, b) => {
                const sortBy = this.currentSort;
                if (this.currentSortOrder === 'desc') {
                    return a[sortBy].localeCompare(b[sortBy]);
                }
                return b[sortBy].localeCompare(a[sortBy]);
            });
        },
        handleViewItem (item) {
            this.$emit('viewRow', item);
        },
        handleEdit (item) {
            this.$emit('edit', item);
        },
        formatColumnName (item) {
            const underScoreId = item.replace('_id', '');
            const underScore = underScoreId.replace('_', ' ').replace('.', ' ');
            return underScore.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word) {
                return word.toUpperCase();
            }).replace(/\s+/g, ' ');
        },
        handleDelete (item) {
            console.log(item);
            let name = item.name ? item.name : '';
            Swal.fire({
                title: 'Are you sure?',
                text: `Remove ${this.listType} '${name}' from ${this.type} ${this.model.name}`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonClass: 'md-button md-success btn-fill',
                cancelButtonClass: 'md-button md-danger btn-fill',
                confirmButtonText: 'Yes, delete it!',
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.$emit('removeRow', item);
                }
            });
        },
      handleEnd (item) {
        Swal.fire({
          title: 'Are you sure?',
          text: `End ${this.listType}  for ${this.model.name}`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonClass: 'md-button md-success btn-fill',
          cancelButtonClass: 'md-button md-warning btn-fill',
          confirmButtonText: 'Yes, End it!',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$emit('endRow', item);
          }
        });
      },
      handleRemove (item) {
        console.log(item);
        let name = item.name ? item.name : '';
        Swal.fire({
          title: 'Are you sure?',
          text: `Remove ${this.listType} '${name}' from ${this.type} ${this.model.name}`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonClass: 'md-button md-success btn-fill',
          cancelButtonClass: 'md-button md-danger btn-fill',
          confirmButtonText: 'Yes, delete it!',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$emit('deleteRow', item);
          }
        });
      },
        getNestedProperty (obj, path) {
            const value = path.split('.').reduce((acc, part) => acc && acc[part], obj) || 'N/A';
            // If the value is falsy (e.g., null or undefined), return 'N/A' immediately.
            if (!value) {
                return 'N/A';
            }

            // Check the path string for specific keywords.

          if (path.includes('_date') && value !== 'N/A') {
            const hasTime = /:/.test(value);

            return this.toLocal(value,hasTime?'YYYY-MM-DD HH:mm':'YYYY-MM-DD');
          }

            // if (path.includes('time')) {
            //     return this.toLocal(value, 'YYYY-MM-DD HH:mm');
            // }
            if (path.includes('created_at')) {
                // Assuming you have a displayTimeLocal method defined.
                return this.toLocal(value, 'YYYY-MM-DD HH:mm');
            }
            if (path.includes('createdAt')) {
                // Assuming you have a displayTimeLocal method defined.
                return this.toLocal(value, 'YYYY-MM-DD HH:mm');
            }

            // For all other cases, return the raw value.
            return value;
        },
        getStatusBadgeClass (status) {
            return this.statusClassMap[status] || 'warning';
        }
    },
    mounted () {
    // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
            keys: this.tableColumns,
            threshold: 0.3
        });
    },
    computed: {
        queriedData () {
            let result = this.tableData;
            if (this.searchQuery.length > 0) {
                result = this.searchedData;
            }
            return result.slice(this.from, this.to);
        },
        to () {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total () {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.tableData.length;
        }
    },
    watch: {
        searchQuery (value) {
            let result = this.tableData;
            if (value !== '') {
                result = this.fuseSearch.search(this.searchQuery);
            }
            this.searchedData = result;
        }
    }
};
</script>
<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
